import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-environment-paginator',
  templateUrl: './environment-paginator.component.html',
  styleUrl: './environment-paginator.component.scss',
  standalone: false
})
export class EnvironmentPaginatorComponent implements OnInit {
  @Output() readonly page: EventEmitter<PageEvent> = new EventEmitter<PageEvent>();
  @Output() pageChange = new EventEmitter<{ pageIndex: number; pageSize: number }>();


  @Input()
  set length(newLength: number) {
    this._length = newLength;
    this.initialize();
  }
  get length(): number {
    return this._length;
  }

  @Input()
  set pageIndex(newPageIndex: number) {
    this._pageIndex = newPageIndex;
  }
  get pageIndex(): number {
    return this._pageIndex;
  }

  @Input()
  set pageSize(newPageSize: number) {
    this._pageSize = newPageSize;
    this.initialize();
  }
  get pageSize(): number {
    return this._pageSize;
  }

  @Input()
  set rangeSize(newRangeSize: number) {
    this._rangeSize = newRangeSize;
    this.initialize();
  }
  get rangeSize(): number {
    return this._rangeSize;
  }

  @Input()
  set pageSizeOptions(newPageSizeOptions: number[]) {
    this._pageSizeOptions = newPageSizeOptions;
  }
  get pageSizeOptions(): number[] {
    return this._pageSizeOptions;
  }

  initialized = false;
  numberOfPages: number;
  range: number[];

  private _length: number;
  private _pageIndex = 0;
  private _pageSize = 5;
  private _pageSizeOptions = [5, 10, 20, 50];
  private _rangeSize = 5;

  constructor() { }

  ngOnInit(): void {
    this.initialized = true;
    this.initialize();
  }

goToPage(page: number) {
  const previousPageIndex = this.pageIndex;
  this.pageIndex = page;
  this.calculateRange();
  this.page.emit({
      previousPageIndex,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.length,
  });
}

  pageSizeChanged(): void {
    this.initialize();
  }

  private initialize(): void {
    if (!this.initialized) {
      return;
    }

    if (this.length == null || this.length < 0) {
      this.length = 0;
    }

    this.numberOfPages = Math.floor(this.length / this.pageSize) + (this.length % this.pageSize > 0 ? 1 : 0);
    if (this.numberOfPages <= this.pageIndex) {
      this.pageIndex = this.numberOfPages === 0 ? 0 : this.numberOfPages - 1;
    }

    this.calculateRange();

    this.page.emit({
      previousPageIndex: null,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      length: this.length,
    });
  }

  private calculateRange(): void {
    if (this.rangeSize >= this.numberOfPages) {
      this.range = Array.from(Array(Math.min(this.rangeSize, this.numberOfPages)).keys());
    } else {
      let startIndex: number;
      let endIndex: number;

      if (this.pageIndex < this.rangeSize -1) {
        startIndex = 0;
        endIndex = this.rangeSize - 1;
      } else if (this.pageIndex > this.numberOfPages - this.rangeSize) {
        startIndex = this.numberOfPages - this.rangeSize;
        endIndex = this.numberOfPages - 1;
      } else {
        const halfRangeSize = Math.floor(this.rangeSize / 2);
        startIndex = this.pageIndex - halfRangeSize + (this.rangeSize % 2 === 0 ? 1 : 0);
        endIndex = this.pageIndex + halfRangeSize;
      }

      this.range = [];
      for (let index = startIndex; index <= endIndex; index++) {
        this.range.push(index);
      }
    }
  }
}

export class PageEvent {
  pageIndex: number;
  previousPageIndex?: number;
  pageSize: number;
  length: number;
}